/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ITEM_ID_DIVISION } from "../../Constants";
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface SearchMasterListPayload {
    itemId: string;
}

export interface SearchMasterListItem {
    code: string;
    value: string;
    companyId: string;
}

export interface SearchMasterListResponse {
    masterList: SearchMasterListItem[];
}

class SearchMasterListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "searchMasterList");
    }

    private async fetchMasterList(itemId: string, resolved: (response: SearchMasterListResponse) => void, rejected: (error: any) => void) {
        await super.postJSON(
            { itemId },
            (json: any) => {
                const response = json as SearchMasterListResponse;
                resolved(response);
            },
            rejected
        );
    }

    public async fetchDivisions(resolved: (response: SearchMasterListResponse) => void, rejected: (error: any) => void) {
        await this.fetchMasterList(ITEM_ID_DIVISION, resolved, rejected);
    }
}

export default SearchMasterListService;
